import { useResolvedTheme } from '../../stores/themeStore'
import logoLight from '../../assets/brand/logo.svg'
import logoDark from '../../assets/brand/logo-dark.svg'

/** The FursaHub wordmark: dark text on light surfaces, white text on dark ones. */
export function useLogo(): string {
  return useResolvedTheme() === 'dark' ? logoDark : logoLight
}
